import { Button } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { AiOutlineArrowLeft } from 'react-icons/ai';

export const BackButton = () => {
  const history = useHistory();
  const onClick = () => {
    history.goBack();
  };
  return (
    <Button
      leftIcon={<AiOutlineArrowLeft />}
      variant="outline"
      onClick={onClick}
    >
      Back
    </Button>
  );
};
